// Envanteri tamamlama süresini insan-okur biçime çevirir.
// ms: toplam milisaniye. Geçersiz / 0 ise "-" döner.

export function formatDuration(ms, language = "tr") {
  const isTR = language !== "en";
  const value = Number(ms);

  if (!Number.isFinite(value) || value <= 0) return "-";

  const totalSeconds = Math.round(value / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes <= 0) {
    return isTR ? `${seconds} sn` : `${seconds} sec`;
  }

  return isTR
    ? `${minutes} dk ${seconds} sn`
    : `${minutes} min ${seconds} sec`;
}

// Kayıttan süreyi (ms) okur. Yeni alan durationMs, eski/yedek alan durationSeconds.
export function getDurationMs(record) {
  if (!record) return 0;
  if (Number.isFinite(Number(record.durationMs))) return Number(record.durationMs);
  if (Number.isFinite(Number(record.durationSeconds))) {
    return Number(record.durationSeconds) * 1000;
  }
  return 0;
}
